"use client";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
} from "@/components/ui/alert-dialog";
import { Badge } from "@/components/ui/badge";
import StrategyTemplate from "@/components/walk-through/explore/StrategyTemplate";
import { motion } from "framer-motion";
import { useRouter } from "next/router";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useStrategyMode } from "@/contexts/StrategyModeContext";

const Banner = () => {
  const router = useRouter();
  const { t } = useTranslation("common-page");
  const { mode } = useStrategyMode();

  const [ftuOpen, setFtuOpen] = useState<boolean>(false);
  // Only show banner on build pages
  if (!router?.pathname?.includes("build")) return null;
  if (mode === "prediction_market") return null;
  return (
    <>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "2rem", opacity: 1 }}
        transition={{ duration: 0.3, ease: "linear" }}
        className="overflow-hidden bg-[--accent-primary] sm:h-8 h-12 flex gap-4 items-center sm:px-10 sm:text-base font-extrabold text-center  text-xs px-8"
      >
        {" "}
        <Badge className="text-[--accent-primary] ">{t("NEW")}</Badge>{" "}
        <p>
          {t("Explore ready-made strategies with zero setup or risk.")}{" "}
          <span
            onClick={() => setFtuOpen(true)}
            className="hover:font-extrabold underline underline-offset-2 cursor-pointer"
          >
            {t("Try them in paper trading mode now")}
          </span>
        </p>
      </motion.div>
      <AlertDialog open={ftuOpen} onOpenChange={(open) => setFtuOpen(open)}>
        <AlertDialogContent className="max-w-5xl px-3 ">
          <div className="w-full flex flex-col">
            <StrategyTemplate />
            <div className="w-full flex justify-end mt-2">
              <AlertDialogCancel>
                <>{t("Close")}</>
              </AlertDialogCancel>
            </div>
          </div>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default Banner;
